import { render, staticRenderFns } from "./AsRegisterNewAccountButton.vue?vue&type=template&id=6db0e3c0&scoped=true"
import script from "./AsRegisterNewAccountButton.vue?vue&type=script&lang=js"
export * from "./AsRegisterNewAccountButton.vue?vue&type=script&lang=js"
import style0 from "./AsRegisterNewAccountButton.vue?vue&type=style&index=0&id=6db0e3c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db0e3c0",
  null
  
)

export default component.exports